import { render, staticRenderFns } from "./documentInfo.vue?vue&type=template&id=c1bff030&scoped=true&"
import script from "./documentInfo.vue?vue&type=script&lang=js&"
export * from "./documentInfo.vue?vue&type=script&lang=js&"
import style0 from "./documentInfo.vue?vue&type=style&index=0&id=c1bff030&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bff030",
  null
  
)

export default component.exports